import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { getRolesSelector } from '../../reducers/roles';
import { getRightsByLockingsIdSelector } from '../../reducers/rights';
import { getNestMapLockingsSelector } from '../../reducers/lockings';
import { getExtraRowsNumberSelector } from '../../reducers/app';
import { getCollapsedGroups } from '../../reducers/app/collapsedGroups';

import { addRightsRequest, deleteRightsRequest } from './rightsActions';

import RightsTableData from './RightsTableData';
import RightsTableDataCheckbox from './RightsTableDataCheckbox';

class LockingsAllRightsContainer extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div>
				{this.props.lockings.map(locking => this.renderRow(locking))}
				{this.generateEmptyRows()}
			</div>
		);
	}

	renderRow(locking) {
		if (locking && locking.children) {
			return this.renderGroupRows(locking);
		}
		if (locking) {
			return this.renderLockingRow(locking);
		}
	}

	renderGroupRows(locking) {
		const rows = [];
		rows.push(this.renderEmptyRow(locking.locking_id));

		const isCollapsed = this.props.collapsedGroups[locking.locking_id];
		if (!isCollapsed) {
			locking.children.forEach(locking =>
				rows.push(this.renderLockingRow(locking))
			);
		}
		return rows;
	}

	renderLockingRow(locking) {
		const hasAllRights =
			Object.keys(this.props.rightsMap[locking.locking_id]).length ===
			this.props.roles.length;
		return (
			<div className="rights-table__row" key={locking.locking_id}>
				<RightsTableDataCheckbox
					checked={hasAllRights}
					onClick={() =>
						this.props.toggleRights(
							this.props.roles,
							locking,
							hasAllRights
						)}
				/>
			</div>
		);
	}

	generateEmptyRows() {
		const rows = [];
		for (let i = 0; i < this.props.extraRowsNumber; i++) {
			rows.push(this.renderEmptyRow(i));
		}
		return rows;
	}

	renderEmptyRow(key) {
		return (
			<div className="rights-table__row" key={key}>
				<RightsTableData />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		roles: getRolesSelector(state),
		rightsMap: getRightsByLockingsIdSelector(state),
		lockings: getNestMapLockingsSelector(state),
		extraRowsNumber: getExtraRowsNumberSelector(state),
		collapsedGroups: getCollapsedGroups(state)
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	const { projectId } = ownProps.params;
	return {
		toggleRights: (roles, locking, hasAllRights) => {
			const toggle = hasAllRights
				? deleteRightsRequest
				: addRightsRequest;

			dispatch(toggle(projectId, roles, [locking]));
		}
	};
}

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(LockingsAllRightsContainer)
);



// WEBPACK FOOTER //
// ./src/js/plan/rights/LockingsAllRightsContainer.js